import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import WishlistFriendLink from 'Components/Wishlist/WishlistFriendLink';

const WishlistFriendsContainer = ({
  friends,
  wishlistId,
  wishlistDisplayName,
  isPrivate,
  fromAccount,
}) => {
  const alreadyHasFriend = !!friends.find(friend => friend.wishlist_id === wishlistId);

  let profilesToDisplay = friends;

  const wishlistProfile = {
    wishlist_id: wishlistId,
    wishlist_display_name: wishlistDisplayName,
  };

  if (wishlistId && wishlistDisplayName && !isPrivate && !alreadyHasFriend) {
    profilesToDisplay = [wishlistProfile, ...friends];
  }

  return (
    <React.Fragment>
      {profilesToDisplay.map(friend =>
        <WishlistFriendLink
          key={friend.wishlist_id}
          selected={friend.wishlist_id === wishlistId}
          wishlistId={friend.wishlist_id}
          wishlistDisplayName={friend.wishlist_display_name}
          fromAccount={fromAccount}
        />,
      )}
    </React.Fragment>
  );
};

WishlistFriendsContainer.propTypes = {
  friends: PropTypes.arrayOf(PropTypes.object),
  wishlistId: PropTypes.string,
  wishlistDisplayName: PropTypes.string,
  isPrivate: PropTypes.bool,
  fromAccount: PropTypes.bool,
};

WishlistFriendsContainer.defaultProps = {
  authenticated: false,
  friends: [],
  wishlistId: '',
  wishlistDisplayName: '',
  isPrivate: false,
  fromAccount: false,
};

const mapStateToProps =
({
  wishlist: { friends },
}) => ({
  friends,
});

export default connect(mapStateToProps)(WishlistFriendsContainer);
